// extracted by mini-css-extract-plugin
export default {"divider":"g__divider--Lit8K","divider-line":"g__divider-line--Chsps"};